var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnnotationSubmitted = function SvgAnnotationSubmitted(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 10,
    height: 10,
    fill: "currentColor",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 8,
    height: 8,
    stroke: "currentColor",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 4,
    height: 4,
    rx: 2,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 4,
    height: 4,
    rx: 2,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 4,
    height: 4,
    rx: 2,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 4,
    height: 4,
    rx: 2,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotationSubmitted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "annotation-submitted.2ea89704c8505cdfa0c19f4d72e6bf41.svg";